import api from '@/api'
import { DeleteMode } from '@/modules/mail/types';
import { ContactsStoredType } from '../types/enums'

export default{
    /**
     * 새로운 연락처를 생성합니다
     * @param data 전달되는 데이터
     * @param type DB,exchange 버전 구분
     */
    createContact(data: mail.api.DynamicApiOptions, type: ContactsStoredType): Promise<string>{
        return api.post({
            url: '/api/ews/Contact/create?type='+type,
            data: data
        });
    },
    /**
     * 연락처를 수정합니다.
     * @param data 전달되는 데이터
     * @param type DB,exchange 버전 구분
     */
    editContact(data: mail.api.DynamicApiOptions, type: ContactsStoredType): Promise<boolean>{
        return api.post({
            url: '/api/ews/Contact/set?type='+type,
            data: data
        });
    },
    /**
     * 선택한 연락처를 해당 주소록 폴더로 복사합니다.
     * @param {object} ids 연락처 ID
     * @param {string} folderId 폴더 ID
     * @param {enum} type DB,exchange 버전 구분
     */
    copyContact: function(ids: Array<string>, folderId: string, type: ContactsStoredType): Promise<string>{
        var id = encodeURIComponent(folderId);
        return api.post({
            url: `/api/ews/Contact/copy?type=${type}&folderId=${id}`,
            data: ids
        });
    },
    /**
     * 연락처를 삭제합니다.
     * @param {object} ids 
     * @param {string} mode 삭제 방법 구분
     * @param {enum} type DB,exchange 버전 구분
     */
    deleteContacts (ids: Array<string>, mode: DeleteMode, type: ContactsStoredType): Promise<boolean> {
        return api.delete({
            url: `/api/ews/Contact/?type=${type}&deleteMode=${mode}`,
            data: ids
        });
    },
    /**
     * 선택한 연락처를 해당 주소록 폴더로 이동시킵니다.
     * @param {object} ids 연락처 ID
     * @param {string} folderId 폴더 ID
     * @param {enum} type DB,exchange 버전 구분
     */
    moveContact: function(ids: Array<string>, folderId: string, type: ContactsStoredType): Promise<string>{
        var id = encodeURIComponent(folderId);
        return api.post({
            url: `/api/ews/Contact/move?type=${type}&folderId=${id}`,
            data: ids
        });
    },

    getContactPhoto(id: string){
        return api.post({
            url: '/api/ews/Dynamic/get',
            data: {
                fields: [
                    { 
                        key: 'Attachments',
                        serialize: true,
                        filters: [
                            { key: 'isContactPhoto' , value: true, operator: 'eq' }
                        ]
                    }
                ],
                itemId: id,
                type: 'Contact'
            }
        })
    },

    /**
     * 연락처 목록을 조회합니다.
     * @param {object} data
     * @param {enum} type DB,exchange 버전 구분 
     */
    getContactsList(data: mail.api.DynamicApiOptions, type: ContactsStoredType): Promise<PagedItemList<contacts.ContactItem>> {
        return api.post<PagedItemList<contacts.ContactItem>>({
            url: '/api/ews/contact/list?type='+type,
            data: {
                fields: [
                    { key: 'Id' },
                    { key: 'DisplayName'},
                    { key: 'Surname' },
                    { key: 'GivenName' },
                    { key: 'CompanyName' },
                    { key: 'Department' },
                    { key: 'JobTitle' },
                    { key: 'OfficeLocation' },
                    { key: 'ItemClass' },
                    { key: 'HasPicture' },
                    { key: 'PhoneNumbers', indexedKey: 'MobilePhone', as: 'mobile'},
                    { key: 'PhoneNumbers', indexedKey: 'BusinessPhone', as: 'businessPhone'},
                    { key: 'PhoneNumbers', indexedKey: 'BusinessFax', as: 'businessFax'},
                    // { key: 'EmailAddresses', indexedKey: 'EmailAddress1', format: '{address}', as: 'email'},
                    { key: 'PidLidEmail1OriginalDisplayName', as: 'email'},
                    { key: 'PhysicalAddresses', indexedKey: 'Business', serialize: true, as: 'businessAddress'},
                    { key: 'PhysicalAddresses', indexedKey: 'Home', serialize: true, as: 'homeAddress'},
                    { key: 'BusinessHomePage', indexedKey: 'BusinessHomePage' },
                    {
                        key: 'Attachments',
                        indexedKey: 'Attachments',
                        serialize: true,
                        filters: [
                            { key: 'isContactPhoto', value: true, operator: 'eq' }
                        ]
                    },
                    { key: 'USER_IS_FAVORITE'},
                    ...data.fields
                ],
                filters: data.filters,
                parentId: data.parentId,
                pageSize: data.pageSize,
                offset: data.offset,
                sorts: data.sorts,
                wellKnownParentName: data.wellKnownParentName,
                type: data.type

            } as mail.api.DynamicApiOptions
        }).then((res: PagedItemList<contacts.ContactItem>) => {
            let list =  res.items.map((item: contacts.ContactItem) => {
                var item = {
                    ...item,
                    id: item.id.toString(),
                    selected: false,
                    storedType: type,
                    isFavorite: type === ContactsStoredType.EWS ? item.isFavorite === 'True' : item.isFavorite,
                    type: type === ContactsStoredType.EWS ? ( item.itemClass === 'IPM.Contact' ? 'C' : 'G') : item.type
                } as contacts.ContactItem;
                return item;
            });
            res.items = list;
            
            return res;
        });
    },
}